import React from 'react'
import { Box } from '@mantine/core'
import AppText from './AppText'

export type ProfileStatItem = {
  label: string;
  value: number | string;
  accent?: boolean;
  onClick?: () => void;
}

export type ProfileStatStripProps = {
  items: ProfileStatItem[];
}

export default function ProfileStatStrip ({ items }: ProfileStatStripProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        boxSizing: 'border-box',
        overflowX: 'auto',
        WebkitOverflowScrolling: 'touch',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
        borderBottom: '1px solid var(--gs-border)'
      }}
    >
      {items.map((item, i) => (
        <Box
          key={item.label}
          component={item.onClick ? 'button' : 'div'}
          type={item.onClick ? 'button' : undefined}
          onClick={item.onClick}
          sx={{
            flex: '0 0 auto',
            flexShrink: 0,
            boxSizing: 'border-box',
            border: 'none',
            background: 'none',
            cursor: item.onClick ? 'pointer' : 'default',
            borderRight: i < items.length - 1 ? '1px solid var(--gs-border)' : 'none',
            padding: '12px var(--gs-md)',
            textAlign: 'center',
            '&:hover': item.onClick ? { '& .profile-stat-num': { color: 'var(--gs-accent)' } } : {}
          }}
        >
          <AppText
            className="profile-stat-num"
            sx={{
              fontFamily: 'Oswald, sans-serif',
              fontWeight: 700,
              fontSize: 20,
              color: item.accent ? 'var(--gs-accent)' : 'var(--gs-text)',
              lineHeight: 1.1
            }}
          >
            {item.value}
          </AppText>
          <AppText
            sx={{
              fontFamily: 'DM Sans, sans-serif',
              fontSize: 10,
              color: 'var(--gs-muted)',
              textTransform: 'uppercase',
              letterSpacing: 0.8,
              whiteSpace: 'nowrap'
            }}
          >
            {item.label}
          </AppText>
        </Box>
      ))}
    </Box>
  )
}
